import React from "react";
import styled from "styled-components";
import {
  DialogContent,
  Dialog,
  Typography,
  DialogActions,
} from "@mui/material";

import {
  CancelButton,
  PrimaryLoadingButton,
} from "../../../css components/Button";
import { colors } from "../../../css components/Style";

const Card = styled(Dialog)`
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
`;

export default function LockMyCampaignDialog({
  dialog,
  setDialog,
  handleLockCampaign,
  lockCampaignLoading,
}) {
  const handleClose = () => {
    setDialog(false);
  };

  return (
    <Card open={dialog.state} onClose={handleClose}>
      <DialogContent style={{ gap: "40px" }}>
        <Typography color={colors.publicisBlue} variant="h4">
          Are you sure you want to {dialog.heading}?
        </Typography>

        <DialogActions
          style={{ width: "100%", textAlign: "end", marginTop: "20px" }}
        >
          <CancelButton onClick={() => handleClose()} variant="outlined">
            Cancel
          </CancelButton>

          <PrimaryLoadingButton
            onClick={() => dialog.func()}
            variant="contained"
            loading={lockCampaignLoading}
          >
            Confirm
          </PrimaryLoadingButton>
        </DialogActions>
      </DialogContent>
    </Card>
  );
}
